// extracted by mini-css-extract-plugin
export default {"material":"material_material__X8BD7"};